/**
 * Registry of Posthog feature flag keys. Adding one? Please follow the naming, lifecycle and
 * definition of done conventions in Feature-Based Development first:
 * https://unz.atlassian.net/wiki/x/VwA-yw
 */
export const FeatureFlags = {
  CHUNKS_PRODUCT_IMPORT_ENABLED: 'CHUNKS_PRODUCT_IMPORT_ENABLED',
  PAYMENT_OPTIONS_REPORT_V2: 'PAYMENT_OPTIONS_REPORT_V2',
  WEBHOOKS_V2: 'WEBHOOKS_V2',
  UOD_USER_MANAGEMENT: 'UOD_USER_MANAGEMENT',
  UOD_2FA_FEATURE: 'UOD_2FA_FEATURE',
  UOD_MMS_HIERARCHY: 'UOD_MMS_HIERARCHY',
  UOD_ORDER_LIST_ORIGIN_CUSTOMER_COLUMNS:
    'UOD_ORDER_LIST_ORIGIN_CUSTOMER_COLUMNS',
  UOD_TRANSACTION_RESULT_FILTER_MULTISELECT:
    'UOD_TRANSACTION_RESULT_FILTER_MULTISELECT',
  SERVICE_STEPS: 'SERVICE_STEPS',
  CUSTOMER_MATCHING: 'CUSTOMER_MATCHING'
}
